export default __webpack_public_path__ + "static/media/directorate.a0d4b8a5.svg";